module.exports = __webpack_public_path__ + "static/imbibe-release.aa469b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imbibe-release.png
// module id = 535
// module chunks = 35783957827783